module.exports = __webpack_public_path__ + "static/img/1b.e787a34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/1b.jpg
// module id = iBHx
// module chunks = 0